import { render, staticRenderFns } from "./CreateProduct.vue?vue&type=template&id=d0c46bb2&"
import script from "./CreateProduct.vue?vue&type=script&lang=js&"
export * from "./CreateProduct.vue?vue&type=script&lang=js&"
import style0 from "./CreateProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports